import $ from 'jquery';
import * as BookingWizard from '../booking-wizard';
import { initializePaymentSummary } from '../payment-summary/payment-summary';

const initializeBrandedFareOffers = () => {
    
    $(document).on('click', 'input[name="brandedfare"]', handleBrandedFareOffersSelection);
}

const updateChoiceButtonState = (id) => {
    $(`.brandedfare-label .choice-button`).each(function (idx) {
        this.classList.remove("selected-button");
        if (this.getAttribute("data-id") == id) {
            this.classList.add("selected-button");
            (this as HTMLButtonElement).textContent = `Selected`;
        } else {
            this.classList.add(this.getAttribute('data-normal-state') ?? '');
            (this as HTMLButtonElement).textContent = `${this.getAttribute("data-content-title")}`;
        }

        $('.brandedfare-label').removeClass('active');
        $('label[for="' + id + '"]').addClass('active');
    });
}

export const handleBrandedFareOffersSelection = (element) => {
    var selectedBrandedFareOfferId = element.target.id;
    var token = $('input[name="__RequestVerificationToken"]', '.active-details-panel').val();
    var bookingId = $('input[name=BookingId]', '#BrandedFareOffersContainer').val();
    updateChoiceButtonState(selectedBrandedFareOfferId);
    $('#wait-total-price').addClass('-with-wait-indicator');
    $.ajax({
        url: "/FlightBooking/SelectBrandedFareOffer",
        method: "POST",
        dataType: "html",
        data: {
            __RequestVerificationToken: token,
            bookingId: bookingId,
            fareId: selectedBrandedFareOfferId
        },
        success: function (result) {
            $('#paymentSummaryRightPanel').html(result);
            BookingWizard.InitializeFareConditionAdvice();
            initializePaymentSummary();
            //Update Book Now button
            const totalPrice = $('.getTotalPrice', '.paymenttotal').text();
            $('.getTotalPrice', '#paymentContinueButton')
                .animate({ opacity: 0.3 }, 300, 'linear', function () {
                    $(this).text(totalPrice);
                })
                .animate({ opacity: 1 }, 500);

        },
        error: function (request, status, error) {
            console.error(request.responseText);
        },
        complete: function () {
            $('#wait-total-price').removeClass('-with-wait-indicator');
        }
    });
    return true;
}
 
$(() => {
    initializeBrandedFareOffers();
});